<template>
  <v-dialog v-model="dialogRunTask" max-width="500">
    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-2">
        <h2>Are you sure you want to run this task?</h2>
      </v-card-title>
      <v-card-text class="pa-0"><p>{{messageText}}</p></v-card-text>
      <v-card-actions class="ma-0 pa-0 pt-1">
        <v-btn @click="runTask()" color="success">Yes, run this task</v-btn>
        <v-btn @click="dialogRunTask = !dialogRunTask" color="error">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CaseTaskRunDialog",
  props: {
    dialogRunTask: Boolean,
    task: { type: Object, required: true }
  },
  computed: {
    messageText() {
      let msg = ""
      if (this.task.name) { msg += this.task.name }
      if (this.task.name && this.task.description) { msg += ": " }
      if (this.task.description) { msg += this.task.description }
      return msg
    }
  },
  methods: {
    runTask() {
      this.$store.dispatch("executeCaseTask", this.task.id)
      this.dialogRunTask = false
    }
  }
}
</script>
